import { useEffect, useState } from "react";
import { useAuthStore, hasValidSession } from "./store/auth";
import LoginPage from "./views/LoginPage";
import Layout from "./components/Layout";
import ContractSigningPage from "./views/ContractSigningPage";

/**
 * Point d'entrée : consomme un éventuel jeton de lien magique présent dans
 * l'URL (`/auth/verify?token=…`), puis affiche l'espace connecté ou la page
 * de connexion.
 */
export default function App() {
  if (window.location.pathname === "/signer") return <ContractSigningPage />;
  return <AuthenticatedApp />;
}

function AuthenticatedApp() {
  const token = useAuthStore((s) => s.token);
  const verify = useAuthStore((s) => s.verify);
  const [consumingLink, setConsumingLink] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const magicToken = params.get("token");
    if (!magicToken) return;
    setConsumingLink(true);
    void verify(magicToken).finally(() => {
      // Nettoie l'URL (retire le jeton de la barre d'adresse et de l'historique).
      window.history.replaceState({}, "", window.location.pathname);
      setConsumingLink(false);
    });
  }, [verify]);

  if (consumingLink) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />
          <p className="text-sm text-slate-500">Connexion en cours…</p>
        </div>
      </div>
    );
  }

  if (!hasValidSession({ token })) {
    return <LoginPage />;
  }
  return <Layout />;
}
